module.exports = __webpack_public_path__ + "img/irc-logo.715d4bf2.png";